import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { EditPencilIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { editPoll } from 'features/one_off_modal';
import { useFetchPollQuery } from '../api';
import { ActionButton } from '../components/action_button';
import { useClosePollSidebar } from '../helpers';
const footerContainerCss = "f1jsq9it";
const FooterContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerContainerCss, props.className)} />;
});
export const Footer = ({
  id
}) => {
  const {
    data: poll,
    isFetching,
    isError
  } = useFetchPollQuery(id);
  const dispatch = useDispatch();
  const closePollSidebar = useClosePollSidebar();
  if (isFetching || isError || poll.status === 'expired') return null;
  const openEditModal = eventTypeId => {
    dispatch(editPoll({
      eventTypeId
    }));
    closePollSidebar();
  };
  return <FooterContainer>
      {poll.status === 'created' && <Button decoration="secondary-outline" onClick={() => openEditModal(id)}>
          <EditPencilIcon />
          {I18n.t('publisher.scheduling.polls.edit_times')}
        </Button>}
      <ActionButton poll={poll} isSidebar />
    </FooterContainer>;
};

require("./footer.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./footer.js");